<template>
  <div>

    <v-data-table

      :headers="headers"
      :items="requests"
      :loading="loading"

      :options.sync="options"
      :server-items-length="totalRequests"

      :footer-props="{
        itemsPerPageOptions: [12,24,48,-1]
      }"
    >
      <template v-slot:item.created_at="{item}">
        {{ $moment.unix(item.created_at).fromNow() }}
      </template>
      <template v-slot:item.actions="{item}">
        <v-btn text small color="error" @click="closeRequest(item)"><v-icon small>mdi-close</v-icon></v-btn>
      </template>
    </v-data-table>
  </div>
</template>

<script>

export default {
  name: 'FoodRequstsBrowser',
  data: () => ({
    loading: true,
    headers: [
      {
        text: 'Name',
        align: 'start',
        value: 'name'
      },
      {
        text: 'Requsted',
        value: 'created_at',
        width: '200px'
      },
      {
        text: '',
        align: 'center',
        value: 'actions',
        width: '50px'
      }
    ],
    requests: [],
    totalRequests: 0,
    options: {
      itemsPerPage: 12,
      sortBy: [
        'created_at'
      ],
      sortDesc: [
        true
      ]
    },
  }),
  mounted: function() {
    this.getDataFromApi();
  },
  watch: {
    options: {
      handler: function() {
        this.getDataFromApi();
      },
      deep: true
    },
    
  },
  computed: {
    isAdmin: function() {
      return this.$store.getters.userIs('food-search-admin');
    }
  },
  methods: {
    getDataFromApi: function() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      let qParams = [];

      this.loading = true;
      qParams.push('f[closed]=0');
      qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      qParams.push('per-page=' + itemsPerPage);
      qParams.push('page=' + page);
      
      this.$http.get('ingredient-requests?' + qParams.join('&'))
        .then(response => {
          this.requests = response.data.items;
          this.totalRequests = response.data._meta.totalCount;
        })
        .catch(err => {
          if(err.response.status == 401) return;

          this.$swal.fire('Error', 'There was an error loading the requests', 'error');
        })
        .finally(() => {
          this.loading = false;
        });
    },

    closeRequest: function(item) {
      this.$swal.fire({
        title: 'Confirm',
        html: 'Are you sure you want to close this requests for <span style="color: #FF0000;">' + item.name + '</span>?',
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'Cancel',
        showLoaderOnConfirm: true
      })
      .then(result => {
        if(result.value) {
          this.$swal.showLoading();
          this.$http.post('ingredient-requests/' + item.id + '/close')
            .then(() => {
              this.getDataFromApi();
              this.$swal.fire({
                title: 'Closed',
                icon: 'success',
                timer: 1000,
                showCancelButton: false,
                animation: true
              });
            })
            .catch(err => {
              console.log(err)
              this.$swal.fire('Error', 'There was an error closing the request', 'error');
            })
        }
      })
    }
  }
}
</script>